import { render, staticRenderFns } from "./PcButton.vue?vue&type=template&id=2452bc55&scoped=true"
import script from "./PcButton.vue?vue&type=script&lang=js"
export * from "./PcButton.vue?vue&type=script&lang=js"
import style0 from "./PcButton.vue?vue&type=style&index=0&id=2452bc55&prod&lang=scss&scoped=true"
import style1 from "./PcButton.vue?vue&type=style&index=1&id=2452bc55&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2452bc55",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
